import { getTranslations } from "lib/translation";
import {
  StyledAccessibility,
  StyledFooter,
  StyledLinks,
  StyledLocale,
  StyledLocaleSwitcher,
  StyledPrivacyPolicy,
} from "./footer.styles";
import { useLocale, useLocales } from "stores/hooks/locale";
import { changeLocale } from "stores/actions/locale";
import { useTranslate } from "stores/hooks/translation";
import { useNavigate } from "react-router";

const Footer = () => {
  const locale = useLocale();
  const locales = useLocales();
  const translate = useTranslate();
  const navigate = useNavigate();

  const openPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  const openAccessibility = () => {
    navigate("/accessibility");
  };

  return (
    <StyledFooter>
      <StyledLocaleSwitcher>
        {locales.map((loc) => {
          const translation = getTranslations(loc);
          return (
            <StyledLocale
              key={loc}
              onClick={() => changeLocale(loc)}
              $active={loc === locale}
            >
              {translation[`show_in_locale_${loc}`]}
            </StyledLocale>
          );
        })}
      </StyledLocaleSwitcher>
      <StyledLinks>
        <StyledPrivacyPolicy onClick={openPrivacyPolicy}>
          {translate("privacy_policy")}
        </StyledPrivacyPolicy>
        <StyledAccessibility onClick={openAccessibility}>
          {translate("accessibility")}
        </StyledAccessibility>
      </StyledLinks>
    </StyledFooter>
  );
};

export default Footer;
